import React, { lazy, Suspense } from 'react'
import { Switch, Route, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';
import InvoiceList from '../Pages/InvoiceList'
import WorkInProgress from '../../../../GlobalModules/Utility/Components/WorkInProgress'

const AddInvoice = lazy(() => import('../Pages/AddInvoice'))
const InvoiceView = lazy(() => import('../Pages/InvoiceView'))
const EditInvoice = lazy(() => import('../Pages/AddInvoice'))

function Loading() {
  return (
    <>
      <div className='wrapper'>
        <span>Loading</span>
      </div>
    </>
  )
}

function InvoiceRoute() {
  const history = useHistory()

  return (
    <Switch>
      <Route
        exact
        path='/:lng/sales/invoices'
        render={() => (
          <React.Fragment>
            <InvoiceList history={history} />
          </React.Fragment>
        )}
      />
      <Route
        exact
        path='/:lng/sales/invoices/view/:slack'
        render={(props) => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <InvoiceView {...props} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path='/:lng/sales/invoices/add'
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <AddInvoice />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path='/:lng/sales/invoices/edit/:slack'
        render={(props) => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <EditInvoice isEdit={true} {...props} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path='/:lng/sales/invoices/list'
        render={() => (
          <React.Fragment>
            <InvoiceList history={history} />
          </React.Fragment>
        )}
      />

      {/* Placeholder routes for future pages */}
      <Route path='/:lng/sales/invoices/:unknown' render={() => <WorkInProgress />} />
    </Switch>
  )
}

const mapStateToProps = (globalState) => ({
  userCredentials: globalState.LoginReducer.userCredentials,
  userEntryType: globalState.LoginReducer.userEntryType
})

export default connect(mapStateToProps)(InvoiceRoute)
